import React, { useEffect, useState } from "react";
import { _, moment } from "../../../../../vendor";
import { dateFormat, timeFormat } from "../../../../utils/FormatHelper";
import * as OrderFunctions from "../../reservations/components/behaviors/OrderFunctions";
import t from "../../../helpers/t";
import { Biscuit } from "../../../../utils";
import { ilockitActions, resourcesActions, useSelector, webFEActions } from "inbooma-api";
import RollingLoader from "./components/RollingLoader";
import { in_array } from "../../../../utils/Helper";
import EmptyLines from "./components/EmptyLines";
import ShowLogDialog from "../../reservations/components/ShowLogDialog";
import { getEnv } from "../../../../Sync";
import showNotification from "../../../helpers/showNotification";

const SupportItem = (props) => {
  const { reservation, dispatch, language, client } = props;
  const endReserv =
    reservation.end !== null &&
    moment(reservation.end).format(dateFormat(language)) !==
      moment(reservation.begin).format(dateFormat(language));
  const [resources, setResources] = useState({});
  const _resources = useSelector((state) => state["resources_data"].getResources);
  const _webFE = useSelector((state) => state["web_fe_data"].webFE_items);
  const [resourcesPending, setResourcesPending] = useState(false);
  const [resourcesPendingArr, setResourcesPendingArr] = useState([]);
  const [usedResources, setUsedResources] = useState([]);
  const [initialized, setInitalized] = useState(false);
  const [showLogDialog, setShowLogDialog] = useState(false);
  const _switchLock = useSelector((state) => state["ilockit_data"].switchLock);
  const [lockPending, setLockPending] = useState(null);

  useEffect(() => {
    if (_switchLock.success === "" || lockPending === null) {
      return;
    }

    if (_switchLock.success === true) {
      showNotification(
        "success",
        lockPending?.id,
        t("Command was sent successfully. Please stay patient, you`ll be notified"),
      );
    } else {
      showNotification("warning", lockPending?.id, _switchLock.data.message);
    }
    // setLockPending(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_switchLock]);

  useEffect(() => {
    if (_webFE !== {} && typeof _webFE.data !== "undefined" && _webFE.data.length > 0) {
      _webFE.data.map((item) => {
        if (
          (item.app === null || item.app === Biscuit.get("user.id")) &&
          item.model === "Resources" &&
          item.environment === getEnv() &&
          typeof resources[item.id] !== "undefined"
        ) {
          alert(item.data);
          setLockPending(null);
          dispatch(webFEActions.removeWebFEItemById({ id: item._id }));
        }
      });
    }
  }, [_webFE]);

  useEffect(() => {
    if (!initialized && !resourcesPending && reservation.checkins.length > 0) {
      let clone = {};
      let res = [];
      Object.assign(clone, resources);
      reservation.checkins.map((checkin) => {
        if (in_array(checkin.resource_id, res)) {
          return;
        }
        res.push(checkin.resource_id);
        clone[checkin.resource_id] = "pending";
        dispatch(
          resourcesActions.getResources({
            token: Biscuit.get("token"),
            suffix: "",
            filter: {
              id: checkin.resource_id,
              find: "WithCoordinates",
              client_id: client.id,
            },
            parameters: {
              headers: {
                "Accept-Language": language,
                "Content-Language": language,
              },
            },
          }),
        );
        setResourcesPending(true);
        setResourcesPendingArr();
      });
      setResources(clone);
      setInitalized(true);
    }
  }, []);

  useEffect(() => {
    if (_resources.success === "" || !resourcesPending) {
      return;
    }
    let clone = {};
    Object.assign(clone, resources);
    if (_resources.success === true) {
      clone[_resources.data[0].id] = _resources.data[0];
      setResources(clone);
    }

    setResourcesPending(false);
  }, [_resources]);

  const onShowLog = () => {
    setShowLogDialog(true);
  };

  const handleCloseDialog = () => {
    setShowLogDialog(false);
  };

  const getCheckin = () => {
    let checkins = reservation?.checkins;
    if (typeof checkins === "undefined" || checkins.length < 1) {
      return "-";
    }
    let first = checkins[0].checkin;
    checkins.map((checkin) => {
      if (checkin.checkin < first) {
        first = checkin.checkin;
      }
    });
    return (
      moment(first).format(dateFormat(language, true)) +
      " " +
      moment(first).format(timeFormat(language))
    );
  };

  const getCheckout = () => {
    let checkins = reservation?.checkins;
    if (typeof checkins === "undefined" || checkins.length < 1) {
      return "-";
    }
    let last = checkins[0].checkout;
    checkins.map((checkin) => {
      if (checkin.checkout !== null && checkin.checkout > last) {
        last = checkin.checkout;
      }
    });
    if (last === null) {
      return "-";
    }
    return (
      moment(last).format(dateFormat(language, true)) +
      " " +
      moment(last).format(timeFormat(language))
    );
  };

  const getCheckinLocation = () => {
    let checkins = reservation?.checkins;
    if (
      typeof checkins === "undefined" ||
      checkins.length < 1 ||
      checkins[0].location_checkin_name === null
    ) {
      return "";
    }
    return checkins[0].location_checkin_name;
  };

  const getCheckoutLocation = () => {
    let checkins = reservation?.checkins;
    if (
      typeof checkins === "undefined" ||
      checkins.length < 1 ||
      checkins[0].location_checkout_name === null
    ) {
      return "";
    }
    return checkins[0].location_checkout_name;
  };

  const getContingentAmount = () => {
    let contingentReservations = reservation?.contingents_reservations;
    if (typeof contingentReservations === "undefined" || contingentReservations.length < 1) {
      return 0;
    }
    let amount = 0;
    contingentReservations.map((cr) => {
      amount += cr.amount;
    });
    return amount;
  };

  let bikeType = "";
  if (typeof client.resourcetypes !== "undefined") {
    _.each(client.resourcetypes, (key, val) => {
      switch (key.id) {
        case 1:
          bikeType = t("Fahrzeuge");
          break;
        case 3:
          bikeType = t("Bikesharing");
          break;
        case 4:
          bikeType = t("Termine");
          break;
        case 5:
          bikeType = t("ParkingLots");
          break;
      }
    });
  }
  const switchLock = (res, e) => {
    if (res.ilockit_device_id !== null) {
      let direction = res?.lock_state === "open" ? "close" : "open";
      let confirmation = window.confirm(
        t("open_lock_warnig_${a}", { a: t(direction + "_lock") }, "capital"),
      );
      if (confirmation) {
        dispatch(
          ilockitActions.switchLock({
            token: Biscuit.get("token"),
            id: res.id,
            direction: direction,
            client_id: res.client_id,
            parameters: {
              headers: {
                "Accept-Language": language,
                "Content-Language": language,
              },
            },
          }),
        );
        setLockPending(res);
      }
    }
  };

  return (
    <>
      <div className="inb-c-item inb-c-item--from row" key="spo">
        <div className="small-2 medium-1 column">
          <span>
            {t("order")}: {reservation?.order?.order_nbr}
          </span>
        </div>
        <div className="small-6 medium-3 column">
          <span>
            {t("booking time")}; {moment(reservation.begin).format(dateFormat(language, true))}{" "}
            {moment(reservation.begin).format(timeFormat(language))} -{" "}
            {endReserv ? moment(reservation.begin).format(dateFormat(language, true)) : ""}{" "}
            {moment(reservation.end).format(timeFormat(language))}
          </span>
        </div>
        <div className="small-4 medium-2 column">
          <span>
            {t("customer")}: {OrderFunctions.getOrderUsername(reservation?.order)}
          </span>
        </div>
        <div className="small-4 medium-2 column">
          <span>
            {t("checkIn")}: {getCheckin()}
          </span>
        </div>
        <div className="small-4 medium-2 column">
          <span>
            {t("checkIn")}: {getCheckout()}
          </span>
        </div>
        <div className="small-4 medium-2 column">
          {t("status")}: {t(reservation.status, null, "capital")}
        </div>

        {/* next row */}
        <div className="small-12 medium-6 column">
          <span>&nbsp;</span>
        </div>
        <div className="small-4 medium-2 column">
          <span>{getCheckinLocation()}</span>
        </div>
        <div className="small-4 medium-2 column">
          <span>{getCheckoutLocation()}</span>
        </div>
        <div className="small-4 medium-2 column">&nbsp;</div>

        {/* next row */}
        <EmptyLines />

        {/* next row */}
        <div className="small-6 medium-3 column">
          <span>
            {t("amount booked ${a}", { a: bikeType })}: {getContingentAmount()}
          </span>
        </div>
        <div className="small-6 medium-3 column">
          <span>
            {t("amount checkins ${a}", { a: bikeType })}: {reservation.checkins.length}
          </span>
        </div>
        <div className="small-12 medium-6 column">
          <span>&nbsp;</span>
        </div>

        {/* next row */}
        <EmptyLines lines={2} />

        {/* next row */}
        <div className="small-12 medium-12 column inb-order-big">
          <span>{bikeType}:</span>
        </div>

        {initialized &&
          reservation.checkins.length > 0 &&
          reservation.checkins.map((checkin) => {
            if (resources[checkin.resource_id] !== "pending") {
              // setUsedResource(null);
              {
                /* next row */
              }
              let facility = "";
              if (
                resources[checkin.resource_id]?.facility_slots?.length > 0 &&
                resources[checkin.resource_id]?.facility_type === "cyclepoint"
              ) {
                facility =
                  " " +
                  resources[checkin.resource_id]?.facility_slots[0]?.facility?.name +
                  " Slot " +
                  resources[checkin.resource_id]?.facility_slots[0]?.facility_slot_nbr;
              }
              return (
                <>
                  <div className="small-6 medium-3 column">
                    <span>
                      ({checkin.resource.resource_nbr}) {checkin.resource.name}
                      {facility}
                    </span>
                  </div>
                  <div className="small-6 medium-6 column">
                    <span>
                      {t("lock")}: {t(resources[checkin.resource_id].lock_state)} |{" "}
                      {t("lock_battery")}: {resources[checkin.resource_id].lock_battery_value}%
                      {resources[checkin.resource_id].battery_value !== null
                        ? " | " +
                          t("resource_battery") +
                          ": " +
                          resources[checkin.resource_id].battery_value
                        : ""}
                    </span>
                  </div>
                  <div className="small-12 medium-3 column">
                    {resources[checkin.resource_id].online && lockPending === null && (
                      <>
                        <input
                          type="button"
                          className="button beautify"
                          value={
                            resources[checkin.resource_id].lock_state === "closed"
                              ? t("open_lock")
                              : t("close_lock")
                          }
                          onClick={(e) => {
                            switchLock(resources[checkin.resource_id], e);
                          }}
                        />
                      </>
                    )}
                    {resources[checkin.resource_id].online && lockPending !== null && (
                      <RollingLoader />
                    )}
                  </div>
                </>
              );
            } else {
              return (
                <>
                  <RollingLoader />
                </>
              );
            }
          })}
        <EmptyLines lines={1} />

        <div className="small-12 medium-12 column inb-order-big">
          <span>
            <button
              type="submit"
              className={
                "button medium beautify beautify-" +
                Biscuit.get("user.client_id") +
                " button-submit round"
              }
              title={t("show log")}
              onClick={onShowLog}
            >
              {t("show log")}
            </button>
          </span>
        </div>
      </div>

      {showLogDialog && (
        <>
          <div
            className="inb-c-listing off-canvas-content"
            id="inb-c-main-orders"
            style={{ minHeight: "1150px", paddingTop: "10px" }}
          >
            <ShowLogDialog
              handleCloseDialog={handleCloseDialog}
              reservation={reservation}
              dispatch={dispatch}
            />
          </div>
        </>
      )}
    </>
  );
};
export default SupportItem;
